/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdWebFeaturesStoreContinueRedirectWithPiRequest
 */
export interface FxIdWebFeaturesStoreContinueRedirectWithPiRequest {
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreContinueRedirectWithPiRequest
     */
    Token: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreContinueRedirectWithPiRequest
     */
    ContinueToken: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreContinueRedirectWithPiRequest
     */
    PIEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FxIdWebFeaturesStoreContinueRedirectWithPiRequest
     */
    PIPhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof FxIdWebFeaturesStoreContinueRedirectWithPiRequest
     */
    AutoConfirm?: boolean | null;
}

/**
 * Check if a given object implements the FxIdWebFeaturesStoreContinueRedirectWithPiRequest interface.
 */
export function instanceOfFxIdWebFeaturesStoreContinueRedirectWithPiRequest(value: object): value is FxIdWebFeaturesStoreContinueRedirectWithPiRequest {
    if (!('Token' in value) || value['Token'] === undefined) return false;
    if (!('ContinueToken' in value) || value['ContinueToken'] === undefined) return false;
    return true;
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestFromJSON(json: any): FxIdWebFeaturesStoreContinueRedirectWithPiRequest {
    return FxIdWebFeaturesStoreContinueRedirectWithPiRequestFromJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdWebFeaturesStoreContinueRedirectWithPiRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'Token': json['Token'],
        'ContinueToken': json['ContinueToken'],
        'PIEmail': json['PIEmail'] == null ? undefined : json['PIEmail'],
        'PIPhoneNumber': json['PIPhoneNumber'] == null ? undefined : json['PIPhoneNumber'],
        'AutoConfirm': json['AutoConfirm'] == null ? undefined : json['AutoConfirm'],
    };
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSON(json: any): FxIdWebFeaturesStoreContinueRedirectWithPiRequest {
    return FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSONTyped(json, false);
}

export function FxIdWebFeaturesStoreContinueRedirectWithPiRequestToJSONTyped(value?: FxIdWebFeaturesStoreContinueRedirectWithPiRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Token': value['Token'],
        'ContinueToken': value['ContinueToken'],
        'PIEmail': value['PIEmail'],
        'PIPhoneNumber': value['PIPhoneNumber'],
        'AutoConfirm': value['AutoConfirm'],
    };
}

